<template>
  <div class="SearchFilter col-sm-12 mobile-sort">
    <div class="row">
      <div class="col-sm-12">
        <strong>{{ store.texter.searchresultblock.sortmobile }}</strong>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <button class="start sortable" v-on:click="sortNamn()" :aria-label="store.resultatSorteringsGrupper.grupp[0].label">
          {{ store.resultatSorteringsGrupper.grupp[0].label }}
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <button class="start sortable" v-on:click="showGrupp(2)" :aria-label="store.resultatSorteringsGrupper.grupp[2].label">
          {{ store.resultatSorteringsGrupper.grupp[2].label }}
          <Svgicon iconName="pil-flytta"></Svgicon>
        </button>
        <div v-if="showingGrupp(2)" class="expanded-content">
          <ul>
            <li v-for="(soretering, index) in store.resultatSorteringsGrupper.grupp[2].soretering" :key="index">
              <label class="anstat-label" :for="soretering.namn">
                <span>
                  <input
                    type="radio"
                    :id="soretering.namn"
                    name="sortering"
                    v-on:click="sortGrupp(soretering.sortering)"
                    :checked="
                      soretering.sortering.sorteringskolumn === store.sort.sorteringskolumn &&
                      soretering.sortering.sorteringsordningdesc === store.sort.sorteringsordningdesc &&
                      soretering.sortering.sorteringsurvalsgrupp === store.sort.sorteringsurvalsgrupp
                    "
                  />
                  <span class="radiocheckmark"></span>
                </span>
                <span>{{ soretering.namn }}</span>
              </label>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div v-if="store.resultatSorteringsGrupper.grupp.length > 3" class="row">
      <div class="col-sm-12">
        <button class="start sortable" v-on:click="showGrupp(3)" :aria-label="store.resultatSorteringsGrupper.grupp[3].label">
          {{ store.resultatSorteringsGrupper.grupp[3].label }}
          <Svgicon iconName="pil-flytta"></Svgicon>
        </button>
        <div v-if="showingGrupp(3)" class="expanded-content">
          <ul>
            <li v-for="(soretering, index) in store.resultatSorteringsGrupper.grupp[3].soretering" :key="index">
              <label class="anstat-label" :for="soretering.namn">
                <span>
                  <input
                    type="radio"
                    :id="soretering.namn"
                    name="sortering"
                    v-on:click="sortGrupp(soretering.sortering)"
                    :checked="
                      soretering.sortering.sorteringskolumn === store.sort.sorteringskolumn &&
                      soretering.sortering.sorteringsordningdesc === store.sort.sorteringsordningdesc &&
                      soretering.sortering.sorteringsurvalsgrupp === store.sort.sorteringsurvalsgrupp
                    "
                  />
                  <span class="radiocheckmark"></span>
                </span>
                <span>{{ soretering.namn }}</span>
              </label>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div v-if="store.resultatSorteringsGrupper.grupp.length > 4" class="row">
      <div class="col-sm-12">
        <button class="start sortable" v-on:click="showGrupp(4)" :aria-label="store.resultatSorteringsGrupper.grupp[4].label">
          {{ store.resultatSorteringsGrupper.grupp[4].label }}
          <Svgicon iconName="pil-flytta"></Svgicon>
        </button>
        <div v-if="showingGrupp(4)" class="expanded-content">
          <ul>
            <li v-for="(soretering, index) in store.resultatSorteringsGrupper.grupp[4].soretering" :key="index">
              <label class="anstat-label" :for="soretering.namn">
                <span>
                  <input
                    type="radio"
                    :id="soretering.namn"
                    name="sortering"
                    v-on:click="sortGrupp(soretering.sortering)"
                    :checked="
                      soretering.sortering.sorteringskolumn === store.sort.sorteringskolumn &&
                      soretering.sortering.sorteringsordningdesc === store.sort.sorteringsordningdesc &&
                      soretering.sortering.sorteringsurvalsgrupp === store.sort.sorteringsurvalsgrupp
                    "
                  />
                  <span class="radiocheckmark"></span>
                </span>
                <span>{{ soretering.namn }}</span>
              </label>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div v-if="store.resultatSorteringsGrupper.grupp.length > 4"></div>
</template>
<script setup lang="ts">
  import { ref } from 'vue';
  import type { AstaSortSettings } from '../../types/AstaTypes';
  import useAstaStore from '../stores/AstaStore';
  import Svgicon from '../components/svgicon.vue';

  const store = useAstaStore();

  const isshowingGrupp = ref(0);

  function showGrupp(index: number) {
    isshowingGrupp.value = isshowingGrupp.value === index ? 0 : index;
  }
  function showingGrupp(index: number): boolean {
    return isshowingGrupp.value === index;
  }
  function sortNamn() {
    if (store.sort.sorteringskolumn === 'anmalningsalternativ') {
      store.setSort({
        sorteringskolumn: 'anmalningsalternativ',
        sorteringsordningdesc: !store.sort.sorteringsordningdesc,
        sorteringsurvalsgrupp: null,
      });
    } else {
      store.setSort({
        sorteringskolumn: 'anmalningsalternativ',
        sorteringsordningdesc: false,
        sorteringsurvalsgrupp: null,
      });
    }
  }
  function sortGrupp(soretering: AstaSortSettings) {
    store.setSort(soretering);
    isshowingGrupp.value = 0;
  }
</script>
